// extracted by mini-css-extract-plugin
module.exports = {"menuDialogClass":"menu-dialog","menuViewsClass":"menu-views","menuTransitionDuration":"300"};